import { get } from '../Services/http';
import { catchError } from './Error.action';

export const VARIANTCHOOSER_LOAD = 'VARIANTCHOOSER_LOAD';
export const VARIANTCHOOSER_LOAD_ERROR = 'VARIANTCHOOSER_LOAD_ERROR';
export const VARIANTCHOOSER_RECEIVE = 'VARIANTCHOOSER_RECEIVE';

export const load = () => (dispatch, getState) => {
    const productId = document.getElementById('hdnProductId').value;
    return get('/api/VariantChooser/' + productId)
        .then(response => response.json())
        .then(data => dispatch(receive(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: VARIANTCHOOSER_LOAD_ERROR,
    payload: {
        error,
    }
})

export const receive = data => {
    return ({
        type: VARIANTCHOOSER_RECEIVE,
        payload: {
            variants: data,
        },
    });
} 